// Create a new file: src/hooks/useDeviceDetection.js
import { useState, useEffect } from 'react';

const useDeviceDetection = () => {
  const [deviceInfo, setDeviceInfo] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    orientation: 'landscape',
    screenWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
    screenHeight: typeof window !== 'undefined' ? window.innerHeight : 0
  });

  useEffect(() => {
    const detectDevice = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      // User Agent detection
      const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      const isTabletUA = /iPad|Android(?=.*Tablet)|Tablet/i.test(navigator.userAgent);
      const isTouchCapable = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      
      // Screen size detection
      // const isMobileWidth = width <= 1024;
      // const isTabletWidth = width > 1024 && width <= 1366;
      const isMobileWidth = width <= 768;
      const isTabletWidth = width > 768 && width <= 1024;
      
      // Determine device type
      let isMobile = false;
      let isTablet = false;
      let isDesktop = true;
      
      if (isMobileUA || (isMobileWidth && isTouchCapable)) {
        isMobile = true;
        isDesktop = false;
      } else if (isTabletUA || (isTabletWidth && isTouchCapable)) {
        isTablet = true;
        isDesktop = false;
      }
      
      // Determine orientation
      const orientation = width > height ? 'landscape' : 'portrait';
            
      setDeviceInfo({
        isMobile,
        isTablet,
        isDesktop,
        orientation,
        screenWidth: width,
        screenHeight: height,
        isMobileWidth,
        isTabletWidth,
        isTabletWidthOrLess: isTabletWidth || isMobileWidth,
        activateMobileView: isMobileWidth 
                            || orientation === 'portrait'
                            
      });
    };

    // Initial detection
    detectDevice();

    // Listen for resize and orientation changes
    const handleResize = () => {
      detectDevice();
    };

    const handleOrientationChange = () => {
      // Small delay to ensure dimensions are updated after orientation change
      setTimeout(detectDevice, 100);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleOrientationChange);
    
    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  return deviceInfo;
};

export default useDeviceDetection;
